// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Data
import CustomPageLayout from "examples/LayoutContainers/CustomPageLayout";
import { Grid } from "@mui/material";
import AddEditTenantAdminForm from "components/Tenants/AddEditTenantAdminForm";
import { useNavigate, useParams } from "react-router-dom";
import { useContext } from "react";
import { addTenantAdmin } from "lib/Api/tenant-admin";
import { LoginFormContext } from "context/loginFormCtx";

function AddTenantAdmin() {
  return (
    <CustomPageLayout>
      <MDBox pt={3} pb={3}>
        <Card>
          <MDBox p={3} lineHeight={1}>
            <Grid container justifyContent="space-between" spacing={3}>
              <Grid item>
                <MDTypography variant="h5" fontWeight="medium">
                  Add Tenant Admin
                </MDTypography>
                <MDTypography variant="button" color="text">
                  Here you can add a new Tenant Admin.
                </MDTypography>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox p={3} lineHeight={1}>
            <AddEditTenantAdminForm />
          </MDBox>
        </Card>
      </MDBox>
    </CustomPageLayout>
  );
}

export default AddTenantAdmin;
